import React from "react";

const ClassicManicureWhy = () => {
  return (
    <div className="nailExtensionMaintain">
      <h5>Why Choose a Classic Manicure at SCENT ?</h5>
      <ul>
        <li>
          <h6>Expert Nail Technicians:</h6> Our team of skilled nail technicians
          are highly trained in the latest manicure techniques. They bring a
          wealth of experience and knowledge to ensure that your nails are
          treated with the utmost care and precision.
        </li>
        <li>
          <h6> High-Quality Products:</h6> At SCENT , we use only the best
          products from reputable brands. Our polishes, lotions, and exfoliants
          are selected for their quality and effectiveness, ensuring that your
          nails not only look great but are also healthy and strong.
        </li>
        <li>
          <h6> Luxurious Environment:</h6> Our salon provides a serene and
          luxurious environment where you can relax and enjoy your manicure.
          From the comfortable seating to the soothing ambiance, every detail is
          designed to enhance your experience.
        </li>
        <li>
          <h6> Hygiene and Safety:</h6> Your health and safety are our top
          priorities. We maintain rigorous hygiene standards, sterilizing all
          tools and equipment before each use. Our salon is kept impeccably
          clean to ensure a safe and comfortable experience for all our clients.
        </li>
      </ul>
    </div>
  );
};

export default ClassicManicureWhy;
